export const redirect = (redirectURL: string): void => {
    window.location.assign(redirectURL)
}
